import {
  Dispatch,
  ReactNode,
  SetStateAction,
  createContext,
  useContext,
  useMemo,
  useState,
} from 'react';

export type DrawerReturnType = {
  drawerId: string;
  isOpen: boolean;
  selectedDrawer: any;
  onOpen: () => void;
  onClose: () => void;
  setSelectedDrawer: (drawer: any) => void;
  onToggle: (drawer: any) => void;
};

export type TopbarConfig = {
  hide: boolean;
};

type UIContextState = {
  drawers: Record<string, DrawerReturnType>;
  setDrawers: Dispatch<SetStateAction<Record<string, DrawerReturnType>>>;
  topbarConfig: TopbarConfig;
  setTopbarConfig: (config: TopbarConfig) => void;
};

export const UIContext = createContext<UIContextState | null>(null);

export function UIProvider({ children }: { children: ReactNode }) {
  const [drawers, setDrawers] = useState<UIContextState['drawers']>({});
  const [topbarConfig, setTopbarConfig] = useState<TopbarConfig>({
    hide: false,
  });

  const state: UIContextState = useMemo(() => {
    return { drawers, setDrawers, topbarConfig, setTopbarConfig };
  }, [drawers, topbarConfig]);

  return <UIContext.Provider value={state}>{children}</UIContext.Provider>;
}

export function useUIContext() {
  const context = useContext(UIContext);
  if (!context) {
    throw new Error('useUIContext must be used within a UIProvider');
  }

  const { setTopbarConfig } = context;

  const hideTopbar = () => setTopbarConfig({ hide: true });
  const showTopbar = () => setTopbarConfig({ hide: false });

  return {
    ...context,
    hideTopbar,
    showTopbar,
  };
}
